module.exports = __webpack_public_path__ + "media/images/arrow-next-frenchblue-1d7bda58.svg";